import { Select } from '@/components/common/SelectField';
import { Field, FieldLabel } from '@/components/ui/field';
import { priorityLabels } from '../../../../data/task-manager';
import { PriorityIcon } from '../../../ui/PriorityIcon';
import { NotePriority } from '@/components/tour/notes/enums';

type Props = {
  value: NotePriority;
  onChange: (value: NotePriority) => void;
};

export function PriorityField({ value, onChange }: Props) {
  const sortedPriorities = [
    NotePriority.Highest,
    NotePriority.High,
    NotePriority.Medium,
    NotePriority.Low,
    NotePriority.Lower,
    NotePriority.Lowest,
  ];

  return (
    <Field>
      <FieldLabel>Priority</FieldLabel>

      <Select
        value={value}
        onChange={(option) => onChange(option.value)}
        options={sortedPriorities.map((priority) => ({
          icon: <PriorityIcon priority={priority} />,
          label: priorityLabels[priority],
          value: priority,
        }))}
      />
    </Field>
  );
}
